import axios from 'axios'
import type { MaybeRef } from 'vue'
import { unref } from 'vue'

// Main axios instance for app-specific APIs
export function setAxiosHeaders({ standard, token }: { standard?: MaybeRef<string>, token?: MaybeRef<string> }) {
  axios.defaults.baseURL = import.meta.env.VITE_API_ROOT
  axios.defaults.headers.common = {
    ...axios.defaults.headers.common,
    ['x-standard-name']: unref(standard),
    Authorization: `Bearer ${unref(token)}`
  }
}

// Dedicated axios instance for auth calls (always points to workspace)
const authAxios = axios.create({
  baseURL: import.meta.env.VITE_AUTH_API_ROOT || import.meta.env.VITE_API_ROOT
})

export function setAuthAxiosHeaders({ standard, token }: { standard?: MaybeRef<string>, token?: MaybeRef<string> }) {
  authAxios.defaults.headers.common = {
    ...authAxios.defaults.headers.common,
    ['x-standard-name']: unref(standard),
    Authorization: `Bearer ${unref(token)}`
  }
}

export { authAxios }
